import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/app/assets/illustration/2 does this sound familiar/webp/cloud.webp");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Alert/Alert.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Button/Button.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Input/Input.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/Link/Link.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/LocaleSwitcher/LocaleSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShareLink"] */ "/codebuild/output/src272999403/src/SleepFront/src/shared/ui/ShareLink/ShareLink.tsx");
